import { v4 as uuid } from 'uuid';

export const buttons = [
  { id: uuid(), name: 'About Us', onclickType: 'about', type: 'about' },
  { id: uuid(), name: 'Why Choose Us', onclickType: 'why', type: 'why' },
  { id: uuid(), name: 'Our Mission', onclickType: 'mission', type: 'mission' },
];

export const aboutSectionInfo = {
  about:
    'We are a very small team of professionals with a passion for working and creating special moments for our clients. Our aim is to create a memorable experience for every guest. We specialize in exploring remote environments, special events and wilderness. We understand the importance of our clients and the needs of our guests. We take the time to understand the needs of our clients and their expectations. We take care of our staff to keep them happy and responsible.',

  why:
    'Researching and organizing your own holiday and flight can be a stressful task. Let us do the work for you! Our platform helps save' +
    'time and effort by providing the shortest routing value for money flight ticket information and activity lists; all you need to do is' +
    'pack and begin your journey.',
  mission:
    'Through travel, we connect people to positive experiences enabling them to see the world differently.We believe that traveling broadens' +
    'the mind and changes the way you think. The people you meet and the experiences you have give you an improved ability to empathize with' +
    'different situations and people.',
  magicalMemories:
    'We are the company you will be proud to see. This is a new technology startup company, we are very proud' +
    'of our technology and our service. So we offer a great customer experience and traveling assistance service.' +
    'Our team consists of experienced professionals with more than 5 years of experience in the field of travel and' +
    'tourism. We are constantly updating our team with new innovations in the field of travel and tourism.' +
    'We’re one of the leading providers of unique attractions in the world, with numerous travel packages to' +
    'choose from and an extensive portfolio of unique destinations, hotels, cafes, museums. Our team of talented' +
    'individuals are dedicated to providing you with high quality, customized solutions that can make your vacation,' +
    'whether it be a short weekend trip to Iceland or a year long journey across the globe.' +
    'Our team of experts can help you find the right package for your holiday. We have built an incredibly' +
    'exciting tool to help you make the best decisions possible. We are committed to make your planning experience' +
    'easy, quick and unforgettable.',
};
